import '@babel/polyfill';
import 'core-js';
import 'array-flat-polyfill';
import VueI18n from 'vue-i18n';
import storeModules from "./store/store-modules.js";
import i18n from "./i18n.js";
import VueSlideUpDown from 'vue-slide-up-down';
import 'formdata-polyfill';
import EventBus from "./plugins/event-bus";


const Components = require.context("./components", true, /\.vue$/i);

Array.prototype.uniqueObject = function (compareProperty) {
    var arr = this;
    return arr
        .map(function (item) {
            return item[compareProperty];
        })
        .map(function (e, i, final) {
            return final.indexOf(e) === i && i;
        })
        .filter(function (e) {
            return arr[e];
        })
        .map(function (e) {
            return arr[e];
        });
};

const ComponentLibrary = {
    install(Vue) {
        Components.keys().forEach(componentFilePath => {
            const componentName = componentFilePath
                .split("/")
                .pop()
                .split(".")[0];
            const component = Components(componentFilePath).default;
            Vue.component(componentName, component);
        });
    }
};

export default ComponentLibrary;

window.EventBus = EventBus;

if (typeof window !== "undefined" && window.Vue) {
    window.Vue.use(ComponentLibrary);

    const NumberFormat = {
        install(Vue) {
            Vue.prototype.$nf = function (number, format, localeTag) {
                if (Number.isInteger(Math.round(number * 100) / 100) && format.endsWith('EUR')) {
                    format = format + '0';
                }

                if ($('body').data('locale-tag')) {
                    localeTag = $('body').data('locale-tag');
                    //if (localeTag === 'en-GB'){
                    //    localeTag = 'sk-SK';
                    //}
                }

                return this.$n(number, format, localeTag);
            }
        },
    };
    window.Vue.use(window.EventBus);
    window.Vue.use(NumberFormat);
    window.Vue.use(VueI18n);
    window.Vue.component('vue-slide-up-down', VueSlideUpDown)
    window.StoreModules = storeModules;
    window.i18n = i18n;
    window.Vue.directive("click-outside", {
        bind: function (el, binding, vNode) {
            // Provided expression must evaluate to a function.
            if (typeof binding.value !== "function") {
                const compName = vNode.context.name;
                let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
                if (compName) {
                    warn += `Found in component '${compName}'`;
                }

                window.console.warn(warn);
            }
            // Define Handler and cache it on the element
            const bubble = binding.modifiers.bubble;
            const handler = e => {
                if (bubble || (!el.contains(e.target) && el !== e.target)) {
                    binding.value(e);
                }
            };
            el.__vueClickOutside__ = handler;

            // add Event Listeners
            document.addEventListener("click", handler);
        },

        unbind: function (el) {
            // Remove Event Listeners
            document.removeEventListener("click", el.__vueClickOutside__);
            el.__vueClickOutside__ = null;
        }
    });
}
